import { onLocaleChanged } from 'owa-strings';
import { orchestrator } from 'satcheljs';
import { fetchItemsViewResource } from 'owa-items-view-strings/lib/services/fetchItemsViewResource';
import { getItemsViewLocale } from 'owa-items-view-strings/lib/utils/getItemsViewLocale';

export async function loadItemsViewStrings() {
    const locale = getItemsViewLocale();

    // #33036: we should merge these files into one set at build time
    const itemsViewPackages = [
        'items-view',
        'items-view-addon-sp',
        'items-view-utilities',
        'odsp-datasources',
        'odsp-list-utilities',
        'odsp-shared-sharing',
        'odsp-utilities',
        'utilities-custom-formatter',
        'utilities-date-time',
        'utilities-office-apps',
    ];

    const resourceResponses = await Promise.all(
        itemsViewPackages.map(packageName => fetchItemsViewResource(packageName, locale))
    );

    (window as any).ItemsViewStrings = resourceResponses.reduce(
        (allStrings, packageStrings) => ({
            ...allStrings,
            ...packageStrings,
        }),
        {}
    );

    initializeItemsViewOrchestrator();
}

let isOrchestratorInitialized = false;

function initializeItemsViewOrchestrator() {
    // We don't really need to start listening for this until the files hub is first loaded
    if (!isOrchestratorInitialized) {
        orchestrator(onLocaleChanged, loadItemsViewStrings);
        isOrchestratorInitialized = true;
    }
}
